import React from 'react';

const SMS: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">SMS Messages</h1>
        <p className="mt-1 text-sm text-gray-500">
          Monitor and manage SMS communications
        </p>
      </div>
      
      <div className="card">
        <p className="text-gray-500">SMS management interface coming soon...</p>
      </div>
    </div>
  );
};

export default SMS;